import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { openStationery } from "./openStationery";

export const openPrinterDialog = async (
  { sectionType, data, type, formCode, formId, serie }: stdObject,
  params: stdObject,
) => {
  // console.log("openPrinterDialog", {
  //   sectionType,
  //   data,
  //   type,
  //   formCode,
  //   formId,
  // });
  const { setDocValues, setStationeryModal, setMsg, closeMsg, logoutAction } =
    params;
  setMsg("loading");
  const isART = sectionType.code === "ART";
  try {
    const payloadPrintDialog: stdObject = {
      sectionType: sectionType.code,
      serie: isART ? serie : data[`SER${sectionType.code}`],
      code: isART ? null : data[`COD${sectionType.code}`],
      formCode,
      formId,
    };
    console.log("payloadPrintDialog", payloadPrintDialog);
    const responsePrintDialog: stdObject = await sendData({
      endPoint: "callStationery",
      payload: payloadPrintDialog,
      logoutAction,
    });
    console.log("responsePrintDialog", responsePrintDialog);
    if (responsePrintDialog.success && responsePrintDialog.status) {
      if (
        responsePrintDialog.data.TIPDOC === "SEV" &&
        responsePrintDialog.data.ADSDOC
      ) {
        const servItem = responsePrintDialog.rows.reduce(
          (acc: stdObject, curr: string) => {
            let value: string | number | any[] = 0;
            switch (curr) {
              case "SERSE0":
                value = responsePrintDialog.documentData.SERSEV;
                break;
              case "CODSE0":
                value = responsePrintDialog.documentData.CODSEV;
                break;
              case "ARTSE0":
                value = responsePrintDialog.documentData.INTSEV;
                break;
              case "NOMSE0":
                value = responsePrintDialog.documentData.INTNSEV;
                break;
              case "DESSE0":
                value = responsePrintDialog.documentData.DESSEV;
                break;
              case "IMPSE0":
                value = responsePrintDialog.documentData.PIMSEV;
                break;
              case "PRESE0":
              case "TOTSE0":
                value = responsePrintDialog.documentData.PRESEV;
                break;
              case "TIPSE0":
              case "CANSE0":
              case "PENSE0":
                value = 1;
                break;
              case "GARSE0":
              case "HUESE0":
              case "CNOSE0":
              case "PIASE0":
              case "UNISE0":
              case "OBSSE0":
                value = "";
                break;
            }
            return { ...acc, [curr]: value };
          },
          {},
        );
        servItem.BATCHES = [];
        responsePrintDialog.lines.unshift(servItem);
      }

      openStationery(
        {
          type: sectionType.code,
          area: responsePrintDialog.area,
          data: responsePrintDialog.data,
          parts: responsePrintDialog.parts,
          doc: responsePrintDialog.doc,
          rows: responsePrintDialog.rows,
          person: responsePrintDialog.person,
          payments: responsePrintDialog.payments,
          prices: responsePrintDialog.prices,
          documentData: responsePrintDialog.documentData,
          formats: responsePrintDialog.formats,
          partsList: responsePrintDialog.partsList,
          branch: responsePrintDialog.branch,
          personData: responsePrintDialog.personData,
          lines: responsePrintDialog.lines,
          paymentsData: responsePrintDialog.paymentsData,
          tickets: isART
            ? data.map((e: stdObject) => {
                return { ...e, selected: true };
              })
            : null,
          mainColor: colors[type],
          sectionId: sectionType.id,
          typeText: type,
          formCode,
          formId,
          formValues: responsePrintDialog.formValues,
          index: -1,
        },
        { setDocValues, setStationeryModal, setMsg, closeMsg, logoutAction },
      );
    }
  } catch (error) {
    console.log("openPrinterDialog error: ", error);
  }
  closeMsg();
};
